// extracted by mini-css-extract-plugin
export default {"input":"Password_input__Sye+7","bigger":"Password_bigger__5tVdi","wrapper":"Password_wrapper__MXfJB","icon":"Password_icon__jTHvU","visibility":"Password_visibility__HZ0dl"};